import React, { Component } from 'react'
import { StyleSheet, css } from 'aphrodite'
import Dialog from '@material-ui/core/Dialog'

import { AppStyles, AppTheme } from '../styles/AppTheme'
import { CustomMessageDialogStyles } from '../styles/CustomStyles'
import { AppConfig } from '../AppConfig'
import { UiHelper } from '../common/helpers/UiHelper'
import { Helper } from '../common/helpers/Helper'
import { AppHelper } from '../helpers/AppHelper';
import { Fade, Slide } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class SubtaskImagePreviewDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentIndex: 0
    }
  }

  onCloseModal() {
    this.props.onClosed()
  }

  handleNextImage = () => {
    if (this.state.currentIndex < this.props.ads.length - 1) {
      this.setState((prevState) => ({ currentIndex: prevState.currentIndex + 1 }))
    }
  }

  handlePrevImage = () => {
    if (this.state.currentIndex > 0) {
      this.setState((prevState) => ({ currentIndex: prevState.currentIndex - 1 }))
    }
  }

  render() {
    const { ads, title, isOpen } = this.props
    const { currentIndex } = this.state

    return (
      <Dialog
        open={isOpen}
        aria-labelledby={title}
        fullWidth={AppHelper.fullWidthCondition()}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          {/* <div className={css(Styles.modalTitle)}>{title}</div> */}
          <div className={css(Styles.modalTitle)}>{Helper.getString('uploadImages')}</div>
          <button
            className={css(Styles.modalCloseButton)}
            onClick={this.onCloseModal.bind(this)}
            disabled={this.state.inProcess}
          >
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <div className={css(Styles.mediaContainer)}>
            <img
              src={ads[currentIndex]}
              alt={`Ad ${currentIndex + 1}`}
              className={css(Styles.contentImage)}
            />
          </div>
          <div className={css(Styles.navigation)}>
            <span onClick={this.handlePrevImage} className={css([Styles.navButton, (currentIndex === 0) ? Styles.iconDisabled : ''])}>
              <i className='material-icons-outlined' >chevron_left</i>
            </span>
            <span>{currentIndex + 1} / {ads.length} Images</span>
            <span onClick={this.handleNextImage} className={css([Styles.navButton, (currentIndex === ads.length - 1) ? Styles.iconDisabled : ''])} >
              <i className='material-icons-outlined' >chevron_right</i>
            </span>
          </div>
        </div>
      </Dialog>
    )
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
  },
  modalTitle: {
    color: '#222222',
    fontSize: 18,
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  modalContent: {
    maxWidth: 400,
    minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
    textAlign: 'center',
  },
  mediaContainer:{
    minWidth: 400,
    '@media (max-width: 1024px)': {
      minWidth: 'unset'
    }
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  contentImage: {
    maxWidth: '100%',
    maxHeight: 400,
    border: 'solid black 1px',
  },
  navigation: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'space-between',
  },
  navButton: {
    border: 'none',
    color: AppTheme.primaryColor,
    cursor: 'pointer'
  },
  iconDisabled: {
    color: '#ccc',
    cursor: 'not-allowed',
    pointerEvents: 'none',
  }
})



// WEBPACK FOOTER //
// ./src/components/SubtaskImagePreviewDialog.js